import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import GlobalSelection from '~/components/molecules/Editorial/Global/GlobalSelection.vue';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

export default {
  name: 'GlobalFooter',
  components: {
    GlobalSelection: GlobalSelection,
    GlobalRichText: GlobalRichText
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref11, _ref12, _ref13;

      return {
        background: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? _ref13.background_color : _ref13 : _ref13) || '',
        textColor: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? _ref12.text_color : _ref12 : _ref12) || '',
        richText: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.rich_text : _ref11 : _ref11) || [],
        selections: this.payload.items.map(function (i) {
          var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10;

          return {
            url: ((_ref10 = i) != null ? (_ref10 = _ref10.url) != null ? _ref10.url : _ref10 : _ref10) || '',
            textColor: ((_ref9 = i) != null ? _ref9.text_color : _ref9) || '',
            title: ((_ref8 = i) != null ? (_ref8 = _ref8.title) != null ? _ref8[0] : _ref8 : _ref8) || null,
            description: ((_ref7 = i) != null ? _ref7.description : _ref7) || null,
            cta: ((_ref6 = i) != null ? _ref6.cta : _ref6) || '',
            image: {
              small: formatPrismicImage((_ref5 = i) != null ? (_ref5 = _ref5.background_image) != null ? (_ref5 = _ref5.small) != null ? _ref5.url : _ref5 : _ref5 : _ref5) || EMPTY_PIXEL,
              large: formatPrismicImage((_ref4 = i) != null ? (_ref4 = _ref4.background_image) != null ? (_ref4 = _ref4.large) != null ? _ref4.url : _ref4 : _ref4 : _ref4) || EMPTY_PIXEL
            },
            tracking: {
              data: {
                event_category: ((_ref3 = i) != null ? _ref3.event_category : _ref3) || '',
                event_action: ((_ref2 = i) != null ? _ref2.event_action : _ref2) || '',
                event_label: ((_ref = i) != null ? _ref.event_label : _ref) || ''
              }
            }
          };
        })
      };
    }
  }
};